import React, { Component } from 'react'
import moment from '../../utils/momentTimeZone'
import ScrollMenu from 'react-horizontal-scrolling-menu'

const listOfMonths = (startDate, nOfMonths) => {
    const months = []
    const currentMonth = startDate
    for (let i = 0; i < nOfMonths * 2; i++) {
        if (i > 0) {
            currentMonth.add(1, 'month')
        }
        if (currentMonth.format('MMMM') === 'January') {
            months.push({
                month: currentMonth.format('YYYY'),
                key: currentMonth.format('YYYY'),
                isYear: true
            })
        }
        months.push({
            month: currentMonth.format('MMMM'),
            key: currentMonth.unix()
        })
    }
    return months
}

const today = moment().startOf('day')

const listOfDays = (startDate, selected) => {
    const days = []
    const currentDay = moment(startDate)

    // Days in this month + all of next month for good measure
    const daysToShow = moment(currentDay).endOf('month').diff(currentDay, 'days') + moment(currentDay).add(1, 'month').daysInMonth()

    for (let i = 0; i < daysToShow; i++) {
        if (i > 0) {
            currentDay.add(1, 'day')
        }
        if (currentDay.isSameOrAfter(today, 'day')) {
            const daysDiff = currentDay.diff(moment.unix(selected), 'days')
            days.push({
                dayOfWeek: currentDay.format('ddd'),
                dayNumber: currentDay.format('DD'),
                key: currentDay.unix().toString(),
                isWeekend: currentDay.day() % 6 === 0,
                isCurrentMonth: currentDay.isSame(startDate, 'month'),
                isInRange: daysDiff <= 7 && daysDiff > 0,
                isLastInRange: daysDiff === 7
            })
        }
    }
    return days
}

const MonthsMenu = (months) => {
    return months.map((month) => (
        <div className={`monthContainer ${month.isYear === true ? 'yearIndicator' : ''}`} key={month.key}>
            <span className="monthName">{month.month}</span>
        </div>
    )
    )
}
const DaysMenu = (days, selected) => {
    return days.map((day) => (
        <div className={`dayContainer ${selected === day.key ? 'active' : ''} ${day.isInRange ? 'inRange' : ''} ${day.isLastInRange ? 'rangeEnd' : ''} ${day.isCurrentMonth ? '' : 'nextMonth'} ${day.isWeekend ? 'weekend' : ''}`} key={day.key}>
            <span className="dayNumber">{day.dayNumber}</span>
            <span className="dayOfWeek">{day.dayOfWeek}</span>
        </div>
    ))
}

const Arrow = ({ icon, className, alt }) => {
    return (
        <div
            className={className}
        ><img width={25} height={25} src={icon} alt={alt} /></div>
    );
};

const ArrowLeft = Arrow({ icon: '/themes/childtheme/assets/img/chevron-left.svg', className: 'arrow-prev arrow', alt: '<' });
const ArrowRight = Arrow({ icon: '/themes/childtheme/assets/img/chevron-right.svg', className: 'arrow-next arrow', alt: '>' });


const DefaultLabel = ({ label, classPrefix }) => {
    return (
        <h5 className={`${classPrefix}--row-label`}>{label}</h5>
    )
}

const DefaultLabelCallback = (label, classPrefix) => {
    return function () {
        return (
            <DefaultLabel label={label} classPrefix={classPrefix} />
        )
    }
}

class CalendarStrip extends Component {

    constructor(props) {
        super(props)

        const today = moment().startOf('day')
        const thisMonth = moment().startOf('month')

        this.today = today
        const startDate = moment.utcUnix(this.props.startDay)
        const startMonth = moment(startDate).startOf('month').startOf('day')

        let earliestDay = startMonth
        if (startMonth.unix() < today.unix()) {
            earliestDay = today
        }

        this.state = {
            startDate: startDate,
            endDate: null,
            selectedDay: startDate.unix().toString(),
            selectedMonth: startMonth.unix().toString(),
            listOfDays: listOfDays(earliestDay, startDate.unix()),
            listOfMonths: listOfMonths(thisMonth, 12),
            lastSelectedValidMonth: startMonth.unix().toString(),
            translateDays: 0,
            translateMonths: 0
        }

        this.classPrefix = this.props.classPrefix || 'c-CalendarStrip'

        this.monthLabel = this.props.monthLabel || DefaultLabelCallback('Jump to', this.classPrefix)
        this.dayLabel = this.props.dayLabel || DefaultLabelCallback('Back to top', this.classPrefix)
    }

    componentDidMount = () => {
        window.addEventListener("whatson:view-today", this.returnToToday)
    }

    componentWillUnmount = () => {
        window.removeEventListener("whatson:view-today", this.returnToToday)
    }

    returnToToday = () => {
        this.onDaySelect(moment().startOf('day').unix())
    }

    onDaySelect = key => {

        const { selectedMonth } = this.state

        const selectedDayMonth = moment.unix(key).startOf('month')
        if (selectedMonth !== selectedDayMonth.unix().toString()) {
            this.setState({
                selectedDay: key,
                selectedMonth: selectedDayMonth.unix().toString(),
                listOfDays: listOfDays(selectedDayMonth, key)
            })
        } else {
            this.setState({
                selectedDay: key,
                listOfDays: listOfDays(selectedDayMonth, key)
            })
        }


        this.props.onDatesChange(key)

    }

    onMonthSelect = key => {

        // Don't react to clicking the year
        if (key.length === 10) {
            const selectedMonth = moment.unix(key)
            let day = moment(selectedMonth).startOf('month').startOf('day')
            if (day.unix() < today.unix()) {
                day = today
            }
            const newDays = listOfDays(selectedMonth, day.unix())

            this.setState({
                selectedMonth: key,
                listOfDays: newDays,
                translateDays: 0,
                lastSelectedValidMonth: key,
                selectedDay: day.unix().toString()
            })

            this.props.onDatesChange(day.unix().toString())
        }

    }

    render() {

        const { selectedDay, selectedMonth, listOfDays, listOfMonths, translateDays, translateMonths } = this.state;
        const days = DaysMenu(listOfDays, selectedDay)
        const months = MonthsMenu(listOfMonths)

        const MonthLabel = this.monthLabel
        const DayLabel = this.dayLabel

        return (
            <div className={`${this.classPrefix} fadeIn`}>
                <div className={`${this.classPrefix}--row`}>
                    <MonthLabel />
                    <div className={`${this.classPrefix}--scroll-menu ${this.classPrefix}__months`}>
                        <ScrollMenu
                            alignCenter={true}
                            arrowLeft={ArrowLeft}
                            arrowRight={ArrowRight}
                            wheel={false}
                            data={months}
                            selected={selectedMonth}
                            hideArrows={true}
                            hideSingleArrow={true}
                            onSelect={this.onMonthSelect}
                            translate={translateMonths}
                        />
                    </div>
                    <DayLabel />
                    <div className={`${this.classPrefix}--scroll-menu ${this.classPrefix}__days`}>
                        <ScrollMenu
                            alignCenter={true}
                            hideArrows={true}
                            wheel={false}
                            hideSingleArrow={true}
                            arrowLeft={ArrowLeft}
                            arrowRight={ArrowRight}
                            data={days}
                            selected={selectedDay}
                            onSelect={this.onDaySelect}
                            translate={translateDays}
                        />
                    </div>
                </div>

            </div>
        )
    }
}

CalendarStrip.defaultProps = {
    onDatesChange: function (unix) { }
}

export default CalendarStrip



// WEBPACK FOOTER //
// ./src/whatson/components/calendar-strip/CalendarStrip.js